import React, { ReactElement } from 'react'

import { Popover, Text, TextProps } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, MantineColor, createStyles, rem } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useIntl } from 'react-intl'

import Tag from 'components/atoms/icons/Tag'
import { useIsMobile } from 'hooks/useIsMobile'

const useStyles = createStyles((theme) => ({
  root: {},
  popoperDropdown: {
    padding: rem(8),
    border: 0,
    backgroundColor: theme.colors.gray[8],
  },
  popoperArrow: {
    backgroundColor: theme.colors.gray[8],
    borderColor: theme.colors.gray[8],
  },
  text: {
    color: '#fff',
  },
  email: {
    color: theme.colors.blue[3],
  },
}))

type Props = {
  label: ReactElement<TextProps>
  color?: MantineColor
  textColor?: MantineColor
  hasTooltip?: boolean
} & BoxProps

const PromotionTag = ({
  label,
  color = 'blue',
  textColor: textColorProp,
  styles,
  className,
  classNames,
  hasTooltip,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const [opened, { close, open }] = useDisclosure(false)
  const { classes, theme, cx } = useStyles(undefined, {
    name: 'PromotionTag',
    styles,
    classNames,
  })
  const textColor = textColorProp || theme.colors?.[color]?.[6]
  const promotionEle = (
    <Box
      className={cx(classes.root, className)}
      sx={{
        background: color.startsWith('#') ? color : theme.colors?.[color]?.[0],
        borderRadius: rem(4),
        padding: '5px 12px 5px 4px',
      }}
    >
      <Text
        size="p4"
        color={textColor}
        sx={{
          display: 'flex',
          gap: rem(4),
          '.icon': {
            marginTop: rem(2),
          },
        }}
      >
        <Tag size={16} color={textColor} className="icon" />
        <span>{label}</span>
      </Text>
    </Box>
  )
  return isMobile || (!isMobile && !hasTooltip) ? (
    promotionEle
  ) : (
    <Popover
      withArrow
      shadow="md"
      opened={opened}
      width={300}
      classNames={{
        dropdown: classes.popoperDropdown,
        arrow: classes.popoperArrow,
      }}
    >
      <Popover.Target>
        <Box
          onMouseEnter={open}
          onMouseLeave={close}
          sx={{
            cursor: 'pointer',
          }}
        >
          {promotionEle}
        </Box>
      </Popover.Target>
      <Popover.Dropdown onMouseEnter={open} onMouseLeave={close}>
        <Text size="p4" className={classes.text}>
          {f(
            {
              id: 'doctorCard.promotionTag.popoverContent',
              defaultMessage:
                'Vui lòng liên hệ hotline 02871096118 hoặc email {email} để nhận ngay voucher ưu đãi.',
            },
            {
              email: (
                <Box
                  component="a"
                  className={classes.email}
                  href="mailto:Hotro@hellobacsi.com"
                >
                  Hotro@hellobacsi.com
                </Box>
              ),
            },
          )}
        </Text>
      </Popover.Dropdown>
    </Popover>
  )
}

export { PromotionTag }
